import { render, staticRenderFns } from "./Tab_document.vue?vue&type=template&id=0da37571"
import script from "./Tab_document.vue?vue&type=script&lang=js"
export * from "./Tab_document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports